let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("blLpm")).then(() => parcelRequire('6Yq66'));